export default "__VITE_ASSET__3ee293f4__"